import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
// import { DirectionService } from '../../core/services/direction.service';

@Injectable({
  providedIn: 'root'
})
export class PersistanceService {

  // $direction: string | null = null;

  constructor(private router: Router) {

  }

  set(key: string, data: any) {
    try {
      return localStorage.setItem(key,data);
    } catch (e) {
      console.error('Error saving to localstorage', e);
      return null;
    }
  }
  get(key: string | object | any) {
    try {
      return localStorage.getItem(key) || "null";
    } catch (e) {
      console.error('Error getting data from localstorage\n', e);
      return null;
    }
  }
  remove(key: string) {
    try {
      return localStorage.removeItem(key);
    } catch (e) {
      console.error('Error removing data from localstorage', e);
      return null;
    }
  }

  isAuthenticated() {
    this.get('token')
  }

  // setLang(lan: string, rtl: string | any, ltr: string | any) {
  //   lan === 'fa' ? (this.direction.setDirection(rtl), this.$direction = 'rtl') : (this.direction.setDirection(ltr), this.$direction = 'ltr');  
  // }

  // getLang() {
  //   let $dir = this.get('exchange-language')
  //   $dir == 'fa' ? this.$direction = 'rtl' : this.$direction = 'ltr';
  // }

  logOut() {
    localStorage.clear();
    return this.router.navigate(['/auth']);
  }

}
